import * as React from 'react';
import styles from './Banner.module.css';
import {
    OptimizedMotionH1,
    OptimizedMotionP,
    OptimizedMotion,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';
import banner from './images/about us.png';

import BackgroundShadow from '../shared/BackgroundShadow';
import { useEffect } from 'react';

const Banner: React.FC = () => {
    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, []);
    return (
        <div className={styles.contentWrapper}>
            <div className={styles.mainContainer}>
                <header className={styles.textContent}>
                    <OptimizedMotionH1 className={styles.title} type="slide-left" delay={0.2}>
                        About SimpleeCreate
                    </OptimizedMotionH1>
                    <OptimizedMotionP className={styles.subtitle} type="slide-left" delay={0.4}>
                        We built SimpleeCreate to take the complexity out of content operations.
                        From brainstorming to publishing, everything happens in one seamless hub.
                    </OptimizedMotionP>
                </header>

                <OptimizedMotion className={styles.imageColumnLarge} type="slide-up" delay={0.4}>
                    <img
                        src={banner}
                        alt="SimpleeCreate showcase image 1"
                        className={styles.primaryImage}
                    />
                </OptimizedMotion>
            </div>
        </div>
    );
};

export default Banner;
